import React from 'react';

interface IconProps extends React.SVGProps<SVGSVGElement> {
  width?: number | string;
  height?: number | string;
  isActive?: boolean;
}

const ArrowUpIcon: React.FC<IconProps> = ({
  width = 16,
  height = 16,
  isActive = false,
  ...props
}) => (
  <svg
    width="12"
    height="7"
    viewBox="0 0 12 7"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M6.00335 2.23308L1.87451 6.45788C1.73407 6.60158 1.56779 6.67113 1.37567 6.66653C1.18356 6.66194 1.01747 6.58759 0.877405 6.44351C0.737342 6.29943 0.667124 6.12929 0.66675 5.93309C0.666375 5.73689 0.736593 5.56694 0.877405 5.42324L5.20286 1.01163C5.31521 0.89667 5.4416 0.81045 5.58204 0.75297C5.72248 0.69549 5.86291 0.666749 6.00335 0.666749C6.14379 0.666749 6.28422 0.69549 6.42466 0.75297C6.5651 0.81045 6.69149 0.89667 6.80384 1.01163L11.1293 5.43761C11.2697 5.58131 11.3377 5.74896 11.3332 5.94056C11.3287 6.13216 11.2561 6.29981 11.1152 6.44351C10.9744 6.58721 10.8082 6.65906 10.6164 6.65906C10.4247 6.65906 10.2586 6.58721 10.1181 6.44351L6.00335 2.23308Z"
      fill="#A5A4AA"
    />
  </svg>
);

export default ArrowUpIcon;
